import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/library/folders/:folderId/members/:memberId`;

type AddFolderLibraryMemberResponse = { status: boolean };
type AddFolderLibraryMemberDTO = {
  memberId: number;
  folderId: number;
};

export const addFolderLibraryMember = ({
  memberId,
  folderId,
}: AddFolderLibraryMemberDTO): Promise<AddFolderLibraryMemberResponse> => {
  const URL = generateRoutePath(url, { folderId, memberId });

  return axios.post(URL);
};

type UseAddFolderLibraryMemberOptions = {
  config?: MutationConfig<typeof addFolderLibraryMember>;
};

export const useAddFolderLibraryMember = ({ config }: UseAddFolderLibraryMemberOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (props) => addFolderLibraryMember(props),
  });
};
